import axios from "axios";

// Default to a relative path so the browser hits whatever origin served the
// page (nginx proxies /api/* to the backend). Set REACT_APP_BACKEND_URL only
// when the API lives on a different origin.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

export const getOverview = async () => {
  const response = await axios.get(`${API}/overview`);
  return response.data;
};

export const getFilters = async () => {
  const response = await axios.get(`${API}/filters`);
  return response.data;
};

export const getCompanies = async (params) => {
  const response = await axios.get(`${API}/companies`, { params });
  return response.data;
};

export const getCompany = async (companyId) => {
  const response = await axios.get(`${API}/companies/${companyId}`);
  return response.data;
};

export const getProjects = async (params) => {
  const response = await axios.get(`${API}/projects`, { params });
  return response.data;
};

export const getMapStateMetrics = async (params) => {
  const response = await axios.get(`${API}/map/metrics/states`, { params });
  return response.data;
};

export const getMapDistrictMetrics = async (params) => {
  const response = await axios.get(`${API}/map/metrics/districts`, { params });
  return response.data;
};

export const getCompanySuggestions = async (params) => {
  const response = await axios.get(`${API}/filters/company-suggestions`, { params });
  return response.data;
};

export const downloadProjectsCsv = async (params) => {
  const response = await axios.get(`${API}/projects/export`, {
    params,
    responseType: "blob",
  });
  return response.data;
};